import { Route, Routes } from 'react-router-dom';
import './App.css';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard/Dashboard';
import AllSubscriptionTable from './components/Dashboard/AllSubscriptionTable';
import './assets/css/main.scss'
import './assets/css/common.scss'
import ContactFilterCategories from './components/Search/ContactFilterCategories';
import SavedSearches from './components/Search/SavedSearches/SavedSearches';
import UploadReport from './components/Report/UploadReport/UploadReport';
import DataCount from './components/Report/DataCount/DataCount';
import Flagged from './components/Settings/Flagged/Flagged';
import UploadCSV from './components/Settings/UploadCSV/UploadCSV';
import Users from './components/Settings/Users/Users';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Profile from './components/Navbar/Profile';
import ViewedContacts from './components/Search/ViewedContacts/ViewedContacts';
import Trash from './components/Settings/Trash/Trash';
import ResetPassword from './components/Navbar/ResetPassword';
import ForgetPassword from './components/ForgetPassword';
import SignUp from './components/SignUp';
import MyList from './components/Search/MyList/MyList';
import { useDispatch, useSelector } from 'react-redux';
import { getFirstLoginStatus, setAiModal, setScreenZize } from './components/redux/action';
import { useEffect, useRef } from 'react';
import OpenAiPage from './components/OpenAiPage';
import AILoader from './components/AILoader';
import UpgradePlan from './components/UpgradePlan/UpgradePlan';
import LinkedInSuccess from './components/LinkedInSuccess';
import AccountPage from './components/Settings/Accounts/AccountPage';
import SubscriptionPage from './components/Subscriptions/SubscriptionPage';
import ActivityLogs from './components/ActivityLogs/ActivityLogs';
import PaymentHistoryPage from './components/PaymentHistory/PaymentHistoryPage';
import DefaultProvider from './components/Settings/DefaultProvider/DefaultProvider';

function App() {
  const login = sessionStorage.getItem("login");
  const planStatus = sessionStorage.getItem("plan_expired");

  const { isAiOpen, openAiLoader, loginStatus } = useSelector(state => state.data);


  const firstLogin = JSON.parse(sessionStorage.getItem("firstLogin"));

  const iframeRef = useRef(null);

  // alert(planStatus)

  useEffect(() => {
    if (isAiOpen && iframeRef.current) {

      const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
      const signInID = signInDetails[0]?.id;
      const sbnID = signInDetails[0]?.sbn_id;
      const role = signInDetails[0]?.role;
      iframeRef.current.onload = () => {
        iframeRef.current.contentWindow.postMessage(
          {
            user_id: parseInt(signInID),
            sbn_id: sbnID,
            role: role
          },
          "*"
        );
      };
    }
  }, [isAiOpen]);

  useEffect(() => {
    const handleResize = () => {
      dispatch(setScreenZize(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(setScreenZize(window.innerWidth));
  }, []);

  useEffect(() => {
    if (firstLogin) {
      dispatch(getFirstLoginStatus(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstLogin])


  let dispatch = useDispatch();

  function closeAI() {
    dispatch(setAiModal(false))
    // document.getElementById("main_app").style.display = "block";
    // document.getElementById("aiSidebar").style.display = "none";
    // document.getElementById("aiFrame").src = "";
  }

  useEffect(() => {
    if (!isAiOpen) {
      dispatch(setAiModal(false))
      document.getElementById("main_app").style.display = "block";
      document.getElementById("aiSidebar").style.display = "none";
      document.getElementById("aiFrame").src = "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAiOpen])



  return (
    <div className="App" id="main_app" style={{ height: '100vh' }}>
      {openAiLoader && <AILoader />}
      <div style={{ width: isAiOpen ? "60%" : "100%", height: "100%" }}>
        {login && loginStatus && <div className="guide-overlay"></div>}
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          {/* <Route path="/" element={login ? <Dashboard /> : <SignIn />} /> */}
          <Route path="/" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Dashboard />}</> : <SignIn />} />
          <Route path="/dashboard" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Dashboard />}</> : <SignIn />} />
          <Route path="/allSubscription" element={login ? <AllSubscriptionTable /> : <SignIn />} />
          <Route path="/contact-filter" element={login ? <>{isAiOpen ? <OpenAiPage /> : <ContactFilterCategories />}</> : <SignIn />} />
          <Route path="/saved-searches" element={login ? <>{isAiOpen ? <OpenAiPage /> : <SavedSearches />}</> : <SignIn />} />
          <Route path="/upload-reports" element={login ? <>{isAiOpen ? <OpenAiPage /> : <UploadReport />}</> : <SignIn />} />
          <Route path="/data-count" element={login ? <>{isAiOpen ? <OpenAiPage /> : <DataCount />}</> : <SignIn />} />
          <Route path="/flagged-contacts" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Flagged />}</> : <SignIn />} />
          <Route path="/upload-csv" element={login ? <>{isAiOpen ? <OpenAiPage /> : <UploadCSV />}</> : <SignIn />} />
          <Route path="/users" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Users />}</> : <SignIn />} />
          <Route path="/profile" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Profile />}</> : <SignIn />} />
          <Route path="/accounts" element={login ? <>{isAiOpen ? <OpenAiPage /> : <AccountPage />}</> : <SignIn />} />
          <Route path="/upgrade_plan" element={login ? <>{isAiOpen ? <OpenAiPage /> : <UpgradePlan />}</> : <SignIn />} />
          <Route path="/viewed-contacts" element={login ? <>{isAiOpen ? <OpenAiPage /> : <ViewedContacts />}</> : <SignIn />} />
          <Route path="/trash" element={login ? <>{isAiOpen ? <OpenAiPage /> : <Trash />}</> : <SignIn />} />
          <Route path="/my-list" element={login ? <>{isAiOpen ? <OpenAiPage /> : <MyList />}</> : <SignIn />} />
          <Route path="/subscriptions" element={login ? <>{isAiOpen ? <OpenAiPage /> : <SubscriptionPage />}</> : <SignIn />} />
          <Route path="/user_activity" element={login ? <>{isAiOpen ? <OpenAiPage /> : <ActivityLogs />}</> : <SignIn />} />
          <Route path="/payment_history" element={login ? <>{isAiOpen ? <OpenAiPage /> : <PaymentHistoryPage />}</> : <SignIn />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/signup" element={login ? <Dashboard /> : <SignUp />} />
          <Route path="/linkedin-success" element={<LinkedInSuccess />} /> 
          <Route path='/default-provider' element={<DefaultProvider />} />
        </Routes>
      </div>
      <div id="aiSidebar" className="ai-sidebar" style={{ width: isAiOpen ? "40%" : "0" }}>
        <div className="ai-header">
          <span>LEADMERGE AI</span>
          <button onClick={closeAI} className="close_btn">X</button>
        </div>
        <iframe id="aiFrame" title='Ai_modal' ref={iframeRef}
          sandbox="allow-scripts allow-same-origin"
          allow="clipboard-read; clipboard-write"></iframe>
      </div>
    </div>
  );
}

export default App;
